<script lang="ts" setup>
  import { useTemplateRef, watch } from 'vue';
  import type { PlayerSession } from '../../../../shared/api/player.ts';
  import { Logo } from '../../../../shared/ui/logo';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import RejoinGameCard from '../RejoinGameCard.vue';
  import SongstarLogoHeader from '../SongstarLogoHeader.vue';
  import GameCodeInput from './GameCodeInput.vue';

  const props = defineProps<{ codeError?: string; error: string; session?: PlayerSession }>();
  defineEmits<{ gameCode: [value: string]; rejoin: [] }>();

  const gameCodeInput = useTemplateRef('game-code-input');

  watch(
    () => props.error || props.codeError,
    (error) => {
      if (error) gameCodeInput.value?.reset();
    },
  );
</script>

<template>
  <MobileViewLayout space="m">
    <template #header>
      <SongstarLogoHeader />
    </template>

    <RejoinGameCard
      v-if="session"
      class="top-slot"
      :session="session"
      hint="Enter a game code below to join as a new player or join another game."
      @rejoin="$emit('rejoin')"
    />
    <Logo v-else />

    <div class="code-entry">
      <h2>Enter game code to join game</h2>
      <GameCodeInput ref="game-code-input" :error="codeError" @game-code="(code: string) => $emit('gameCode', code)" />
      <p class="error">{{ error }}</p>
    </div>
  </MobileViewLayout>
</template>

<style scoped>
  .mobile-view-layout {
    --code-entry-anchor-height: 3rem;
    --top-slot-height: var(--rejoin-game-card-height);
  }

  .top-slot {
    height: var(--top-slot-height);
    position: relative;
  }

  .code-entry {
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.75rem;
    justify-content: center;
    margin-top: calc(var(--code-entry-anchor-height) - var(--top-slot-height));
  }

  h2 {
    font-size: var(--font-size-lg);
    margin: 0 0 0.75rem;
    text-align: center;
  }

  .error {
    color: var(--color-error);
    line-height: 1.5;
    margin: 0;
    min-height: 1.5rem;
    text-align: center;
  }
</style>
